//Import React
import React from "react";
import { Link } from "react-router-dom";
//Import Icon
import financeLogo from '../../assets/icons/financeLogo.svg';
import reportsLogo from '../../assets/icons/reports.svg';
//Import CSS
import './finance.css';

function Finance () {
    return (
        <section className='finance-container flex'>
            <Link to='/finanzas/ejecucionPME' className='box-reports flex' >
                <img src={reportsLogo} alt='Icono de monitoreo ejecución PME' className='icon' />
                <p>Monitoreo Ejecución PME</p>
            </Link>
            <Link to='/finanzas/presupuesto' className='box-reports flex'>
                <img src={financeLogo} alt='Icono de informe de ejecución presupuestaria' className='icon' />
                <p>Ejecución Presupuestaria</p>
            </Link>
        </section>
    )
}

export default Finance;